export default __webpack_public_path__ + "static/media/1Enviro Product Destruction-2.b2ccf17e.png";